<template>
    <div>
        <div class="intro-y box p-5 mt-5">
            <form
                method="post"
                class="grid grid-cols-12 gap-6"
                :class="{ 'disabled-form': loading }"
                @submit.prevent="save"
            >
                <div v-if="loading" class="absolute z-100 left-0 top-0 w-full h-full flex items-center justify-center">
                    <Preloader />
                </div>

                <div class="relative col-span-4">
                    <label for="form-name" class="form-label">
                        Название
                        <sup v-if="v$.formData.name.required" class="text-theme-6">*</sup>
                    </label>
                    <label v-if="v$.formData.name.$errors.length" for="form-name" class="form-input-text-error">
                        {{ getOverrideMessage(v$.formData.name.$errors[0].$message) }}
                    </label>
                    <input
                        id="form-name"
                        v-model="formData.name"
                        type="text"
                        class="form-control w-full"
                        :class="{ 'form-input-error': v$.formData.name.$errors.length }"
                        placeholder=""
                        autocomplete="off"
                    />
                </div>

                <div class="relative col-span-4">
                    <label for="form-name" class="form-label"> Короткое название </label>
                    <input
                        id="form-name"
                        v-model="formData.short_title"
                        type="text"
                        class="form-control w-full"
                        placeholder=""
                        autocomplete="off"
                    />
                </div>

                <div class="relative col-span-4">
                    <label for="form-slug" class="form-label">
                        Ссылка
                        <sup v-if="v$.formData.slug.required" class="text-theme-6">*</sup>
                    </label>
                    <label v-if="v$.formData.slug.$errors.length" for="form-slug" class="form-input-text-error">
                        {{ getOverrideMessage(v$.formData.slug.$errors[0].$message) }}
                    </label>
                    <input
                        id="form-slug"
                        v-model="formData.slug"
                        type="text"
                        class="form-control w-full"
                        :class="{ 'form-input-error': v$.formData.slug.$errors.length }"
                        placeholder=""
                        autocomplete="off"
                    />
                </div>

                <div class="col-span-2 flex items-center">
                    <input
                        id="form-active"
                        v-model="formData.show_on_main_page"
                        class="show-code form-check-switch flex-none mr-0"
                        type="checkbox"
                    />
                    <label for="form-published" class="form-check-label">Опубликовано</label>
                </div>

                <div class="col-span-2 flex items-center">
                    <input
                        id="form-active"
                        v-model="formData.active"
                        class="show-code form-check-switch flex-none mr-0"
                        type="checkbox"
                    />
                    <label for="form-published" class="form-check-label">Активная</label>
                </div>

                <div class="col-span-3 flex items-center">
                    <input
                        id="form-hot"
                        v-model="formData.hot"
                        class="show-code form-check-switch flex-none mr-0"
                        type="checkbox"
                    />
                    <label for="form-published" class="form-check-label">Горящая акция</label>
                </div>

                <!-- <div class="col-span-2 flex items-center pt-6">
                    <input
                        id="form-active"
                        v-model="formData.show_on_main_page"
                        class="show-code form-check-switch flex-none mr-0"
                        type="checkbox"
                    />
                    <label for="form-published" class="form-check-label">Показывать на главной странице</label>
                </div> -->

                <div class="col-span-12 grid grid-cols-12 gap-6">
                    <div class="col-span-6 grid grid-cols-12 gap-3">
                        <div class="relative col-span-8">
                            <label for="form-decks_number_int" class="form-label">
                                Размер скидки
                                <sup v-if="v$.formData.discount_amount.required" class="text-theme-6">*</sup>
                            </label>
                            <label
                                v-if="v$.formData.discount_amount.$errors.length"
                                for="form-decks_number_int"
                                class="form-input-text-error"
                            >
                                {{ getOverrideMessage(v$.formData.discount_amount.$errors[0].$message) }}
                            </label>
                            <input
                                id="form-discount_amount"
                                v-model.number="formData.discount_amount"
                                type="number"
                                min="0"
                                class="form-control w-full"
                                :class="{ 'form-input-error': v$.formData.discount_amount.$errors.length }"
                                placeholder=""
                                autocomplete="off"
                            />
                        </div>

                        <div class="col-span-4">
                            <label for="form-ship_class" class="form-label">
                                Тип скидки
                                <sup v-if="v$.formData.type.required" class="text-theme-6">*</sup>
                            </label>
                            <label
                                v-if="v$.formData.type.$errors.length"
                                for="form-ship_class"
                                class="form-input-text-error"
                            >
                                {{ getOverrideMessage(v$.formData.type.$errors[0].$message) }}
                            </label>
                            <select
                                id="form-type"
                                v-model="formData.type"
                                :disabled="!discountTypes.length"
                                name="type"
                                class="form-select sm:mr-2"
                                :class="{ 'form-input-error': v$.formData.type.$errors.length }"
                                autocomplete="off"
                            >
                                <option v-for="{ value, label } in discountTypes" :key="value" :value="value">
                                    {{ label }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-span-6 grid grid-cols-12 gap-3">
                        <div class="col-span-6">
                            <label for="form-cruise_date" class="form-label">Дата начала</label>
                            <input
                                id="form-from"
                                v-model="formData.from"
                                type="datetime-local"
                                class="form-control w-full"
                                autocomplete="off"
                            />
                        </div>

                        <div class="col-span-6">
                            <label for="form-cruise_date" class="form-label">Дата конца</label>
                            <input
                                id="form-to"
                                v-model="formData.to"
                                type="datetime-local"
                                class="form-control w-full"
                                autocomplete="off"
                            />
                        </div>
                    </div>

                    <div class="col-span-12 grid grid-cols-12 gap-3">
                        <div class="col-span-6">
                            <label for="form-cruise_date" class="form-label">Привязать круиз</label>
                            <Multiselect
                                id="title"
                                v-model="formData.cruise_ids"
                                track-by="title"
                                :options="cruises"
                                mode="tags"
                                label="title"
                                placeholder="Выберите круиз для привязки"
                                :custom-label="customLabel"
                                :hide-selected="false"
                                :filter-results="false"
                                :filterable="false"
                                value-prop="id"
                                :close-on-select="false"
                                :native="false"
                                :searchable="true"
                                :taggable="true"
                                :clear-on-blur="false"
                                no-results-text="Ничего не найдено"
                                no-options-text="Ничего не найдено"
                                @search-change="fetchCruises"
                            >
                                <template #option="{ option }">
                                    <div>
                                        {{ formattedDate(option.departure_date_time) }} | {{ option.ship_title }} |
                                        {{ option.title }}
                                    </div>
                                </template>
                                <template #tag="{ option, handleTagRemove }">
                                    <span class="multiselect-tag" style="white-space: initial" tabindex="-1"
                                        ><span class="multiselect-tag-wrapper">
                                            {{ formattedDate(option.departure_date_time) }} | {{ option.ship_title }} |
                                            {{ option.title }}</span
                                        ><span class="multiselect-tag-remove" @click="handleTagRemove(option, $event)"
                                            ><span class="multiselect-tag-remove-icon"></span></span
                                    ></span>
                                </template>
                            </Multiselect>
                        </div>
                        <div class="col-span-6">
                            <label for="form-cruise_date" class="form-label">Привязать теплоход</label>
                            <Multiselect
                                id="hidden_tag"
                                v-model="formData.ship_ids"
                                :options="ships"
                                mode="tags"
                                placeholder="Выберите теплоход для привязки"
                                :hide-selected="false"
                                :close-on-select="false"
                                :native="false"
                                label="title"
                                :searchable="true"
                                track-by="title"
                                value-prop="id"
                                no-results-text="Ничего не найдено"
                                no-options-text="Ничего не найдено"
                                clear-on-blur="false"
                                @search-change="fetchShips"
                            />
                        </div>
                    </div>

                    <div class="relative col-span-8">
                        <label for="form-search_title" class="form-label">Заголовок для поиска</label>
                        <input
                            id="form-search_title"
                            v-model.number="formData.search_title"
                            type="text"
                            class="form-control w-full"
                            placeholder=""
                            autocomplete="off"
                        />
                        <!-- :class="{ 'form-input-error': v$.formData.search_title.$errors.length }" -->
                    </div>
                </div>

                <div class="relative col-span-8">
                    <label class="form-label">
                        Баннер на главной и детальной странице
                        <sup v-if="v$.formData.main_banner.required" class="text-theme-6">*</sup>
                    </label>
                    <label v-if="v$.formData.main_banner.$errors.length" class="form-image-text-error">
                        {{ getOverrideMessage(v$.formData.main_banner.$errors[0].$message) }}
                    </label>
                    <UploadImageNew
                        v-model="formData.main_banner"
                        recommended-sizes="1170х511px"
                        :can-delete="false"
                        :has-error="!!v$.formData.main_banner.$errors.length"
                    ></UploadImageNew>
                </div>

                <div class="col-span-4">
                    <label class="form-label">Баннер на детальной странице (мобильная версия)</label>
                    <UploadImageNew
                        v-model="formData.main_banner_mobile"
                        :can-delete="false"
                        recommended-sizes="430x200px"
                    ></UploadImageNew>
                </div>

                <!-- <div class="relative col-span-6">
                    <label class="form-label">
                        Изображение в квадратной плитке
                        <sup v-if="v$.formData.preview_image_square.required" class="text-theme-6">*</sup>
                    </label>
                    <label v-if="v$.formData.preview_image_square.$errors.length" class="form-image-text-error">
                        {{ getOverrideMessage(v$.formData.preview_image_square.$errors[0].$message) }}
                    </label>
                    <UploadImageNew
                        v-model="formData.preview_image_square"
                        recommended-sizes="310х310px"
                        :can-delete="false"
                        :has-error="!!v$.formData.preview_image_square.$errors.length"
                    ></UploadImageNew>
                </div> -->

                <div class="relative col-span-6">
                    <label class="form-label">
                        Изображение в горизонтально-прямоугольной плитке
                        <sup v-if="v$.formData.preview_image_hr_rectangle.required" class="text-theme-6">*</sup>
                    </label>
                    <label v-if="v$.formData.preview_image_hr_rectangle.$errors.length" class="form-image-text-error">
                        {{ getOverrideMessage(v$.formData.preview_image_hr_rectangle.$errors[0].$message) }}
                    </label>
                    <UploadImageNew
                        v-model="formData.preview_image_hr_rectangle"
                        recommended-sizes="420x264px"
                        :can-delete="false"
                        :has-error="!!v$.formData.preview_image_hr_rectangle.$errors.length"
                    ></UploadImageNew>
                </div>

                <!-- <div class="relative col-span-6">
                    <label class="form-label">
                        Изображение в вертикально-прямоугольной плитке
                        <sup v-if="v$.formData.preview_image_vr_rectangle.required" class="text-theme-6">*</sup>
                    </label>
                    <label v-if="v$.formData.preview_image_vr_rectangle.$errors.length" class="form-image-text-error">
                        {{ getOverrideMessage(v$.formData.preview_image_vr_rectangle.$errors[0].$message) }}
                    </label>
                    <UploadImageNew
                        v-model="formData.preview_image_vr_rectangle"
                        recommended-sizes="270х650px"
                        :can-delete="false"
                        :has-error="!!v$.formData.preview_image_vr_rectangle.$errors.length"
                    ></UploadImageNew>
                </div> -->

                <!-- <div class="relative col-span-12">
                    <label class="form-label">
                        Изображение на детальной странице
                        <sup v-if="v$.formData.detail_image.required" class="text-theme-6">*</sup>
                    </label>
                    <label v-if="v$.formData.detail_image.$errors.length" class="form-image-text-error">
                        {{ getOverrideMessage(v$.formData.detail_image.$errors[0].$message) }}
                    </label>
                    <UploadImageNew
                        v-model="formData.detail_image"
                        recommended-sizes="1170х300px"
                        :can-delete="false"
                        :has-error="!!v$.formData.detail_image.$errors.length"
                    ></UploadImageNew>
                </div> -->

                <div class="col-span-12">
                    <label for="form-description" class="form-label">Описание</label>
                    <CustomWyswig id="form-description" v-model="formData.description" class="form-control w-full" />
                </div>

                <div class="col-span-12">
                    <label
                        for="form-description"
                        class="form-label"
                        :class="{
                            'text-theme-6': maxLengthShortDescription < stripHtml(formData.short_description).length,
                        }"
                        >Короткое описание (осталось
                        {{ maxLengthShortDescription - stripHtml(formData.short_description).length || 0 }}
                        символов)</label
                    >
                    <CustomWyswig
                        id="form-description"
                        v-model="formData.short_description"
                        class="form-control w-full"
                    />
                </div>

                <div class="col-span-2">
                    <label for="form-order" class="form-label">Вес порядка</label>
                    <input
                        id="form-order"
                        v-model="formData.content_order"
                        type="text"
                        class="form-control w-full"
                        placeholder=""
                        autocomplete="off"
                    />
                </div>

                <div class="col-span-12">
                    <label class="form-label font-bold">Кастомные поля</label>
                    <TeamsTable
                        v-if="custom_fields"
                        v-model="custom_fields"
                        :meta="null"
                        :headers="seoHeaders"
                        class="mb-3"
                    />
                </div>

                <div class="col-span-12 flex items-center justify-end mt-5">
                    <router-link to="#" class="btn btn-secondary w-24 mr-2 mb-2" @click.prevent="redirectToMainPage"
                        >Отмена
                    </router-link>
                    <button type="submit" class="btn btn-primary mb-2 mr-2" @click.prevent="save(true)">
                        Сохранить и выйти
                    </button>
                    <button type="submit" class="btn btn-primary mb-2" @click.prevent="save()">Сохранить</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { errorResponse } from '@/mixins/form/form-mixin';
import Preloader from '@/components/preloader/Main';
import UploadImageNew from '@/components/upload-image/UploadImageNew';
import CustomWyswig from '@/components/base/custom-wyswig/Main';
import { discountsMixin } from '@/mixins/form/discounts-mixin';
import TeamsTable from '@/components/tables/TeamsTable.vue';
import { helper as $h } from '@/utils/helper';
import { formPreparation } from '@/utils/object-to-form-data';
import { pageMixin } from '@/mixins/pageMixin';
import Multiselect from '@vueform/multiselect';
import dayjs from 'dayjs';

export default {
    name: 'Edit',
    components: { TeamsTable, UploadImageNew, Preloader, CustomWyswig, Multiselect },
    mixins: [errorResponse, discountsMixin, pageMixin],
    setup() {
        return { v$: useVuelidate() };
    },
    async created() {
        this.$store.commit('main/setPageHeader', 'Редактирование акции');
        await Promise.all([this.fetchEditParams(), this.fetchCruises(), this.fetchShips()]);
    },
    validations() {
        return {
            formData: {
                name: { required },
                slug: { required },
                type: { required },
                // detail_image: { required },
                discount_amount: { required },
                main_banner_mobile: { required },
                main_banner: { required },
                // preview_image_square: { required },
                // preview_image_vr_rectangle: { required },
                preview_image_hr_rectangle: { required },
            },
        };
    },
    methods: {
        async save(redirect = false) {
            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) {
                this.$notify({ text: 'Заполните все поля правильно', type: 'error' });
                return;
            }

            if (this.stripHtml(this.formData.short_description).length > this.maxLengthShortDescription) {
                this.$notify({
                    text: 'Максимальное кол-во символов ' + this.maxLengthShortDescription,
                    type: 'error',
                });
                return;
            }

            this.loading = true;

            try {
                this.form = this.mapFormData();

                const formData = formPreparation(this.form, { imagesAsObject: true });
                const { data } = await this.axios.post('/discounts/' + this.$route.params.id, formData, {
                    params: { _method: 'patch' },
                });

                this.$notify(data.message || 'Акция обновлена');

                if (redirect) {
                    this.redirectToMainPage();
                    // await this.$router.push({ name: 'discounts' });
                }
            } catch (ex) {
                this.errorResponse(ex);
            } finally {
                this.loading = false;
            }
        },
        formattedDate(date) {
            return dayjs(date).format('DD.MM.YYYY');
        },
        customLabel(option) {
            return `${option.title} (${option.departure_date_time})`;
        },
        getOverrideMessage(message) {
            return $h.getOverrideMessage(message);
        },
        redirectToMainPage() {
            this._pMTransitionToEditPageWithQuery('discounts');
        },
    },
};
</script>

<style scoped></style>
